import React, { createContext, useContext } from "react";

const TimeSheetDetalhesContext = createContext();

export default TimeSheetDetalhesContext;